import api from './client';
import type { Admin, AdminAddonRole, AdminBaseRole, AdminSection, ApprovalKind } from './types';

export interface CreateUserInput {
  email: string;
  password: string;
  name?: string | null;
  role: 'super_admin' | 'user';
  user_type?: AdminBaseRole;
  addons?: AdminAddonRole[];
  approvals?: ApprovalKind[];
  app_access_mode?: 'legacy_all' | 'assigned';
  permissions?: AdminSection[];
  allowed_apps?: string[];
  allowed_tracker_campaigns?: string[];
  allowed_tracker_pwas?: string[];
  assistant_of_admin_id?: string | null;
  read_only?: boolean;
  is_active?: boolean;
}

export interface UpdateUserInput {
  email?: string;
  name?: string | null;
  role?: 'super_admin' | 'user';
  user_type?: AdminBaseRole;
  addons?: AdminAddonRole[];
  approvals?: ApprovalKind[];
  app_access_mode?: 'legacy_all' | 'assigned';
  permissions?: AdminSection[];
  allowed_apps?: string[];
  allowed_tracker_campaigns?: string[];
  allowed_tracker_pwas?: string[];
  assistant_of_admin_id?: string | null;
  read_only?: boolean;
  is_active?: boolean;
}

export async function listUsers() {
  return api.get<{ users: Admin[] }>('/admin/users');
}

export async function createUser(input: CreateUserInput) {
  return api.post<{ user: Admin }>('/admin/users', input);
}

export async function updateUser(id: string, input: UpdateUserInput) {
  return api.patch<{ user: Admin }>(`/admin/users/${id}`, input);
}

export async function changeUserPassword(id: string, password: string) {
  return api.post<{ ok: true }>(`/admin/users/${id}/password`, { password });
}

export async function deleteUser(id: string) {
  return api.delete<{ ok: true }>(`/admin/users/${id}`);
}

export async function getMe() {
  return api.get<{ admin: Admin }>('/admin/auth/me');
}
